import i18n from "@/libs/i18n";
import { get } from "jquery";
const calculatedDrivers = `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers`;

export default {
  namespaced: true,
  state: {
    management: {
      rows:[],
      columns: [
        {
          label: "ID",
          field: "id"
        },
        {
          label: i18n.t("Name"),
          field: "name",
        },
        {
          label: i18n.t("Dimension"),
          field: "dimension",
        },
        {
          label: i18n.t("Formula"),
          field: "formula_splited",
        },
        {
          label: i18n.t("Is P&L Line?"),
          field: "is_pnl_line",
        },
        {
          label: "",
          field: "manage",
        },
      ],
      totalRows: 0,
      limit: 10,
      offset: 0,
      orderField: '',
      
      updateTable: false,
      updateOnUpload: false,

      errorOnLoad: null,

      calculatedDriverForm:{
        dimension:null,
        driver_id: null,
        driver_name: '',
        driver_formula: '=',
        is_pl: false
      },
    },
    results :{
      // rows data
        count: 0,
        offset: 0,
        pageLength: 10,
        rows: [],

        // columns data - CDs
        columns: [
          {
            label: "ID",
            field: "ID",
          }
        ],
        driverLimit: 5,
        driverOffset: 0,
        totalDrivers: null,

        currentDimension: null,
        currentCalculatedDriver: null,
        driversDropdownList: [],
    },
    resultsByDriver:{
      rows: [],

      // columns data - CDs
      columns: [
        {
          label: i18n.t("Dimension"),
          field: "dimension_name",
        },
        {
          label: i18n.t("Driver"),
          field: "calculated_driver_name",
        },
        {
          label: i18n.t("Total"),
          field: "sum_value",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        }
      ],
    },
    pnlDrivers:[],
    lastCalculation:[],
    finAccountsTotal: 0,
  },
  
  mutations: {
    SET_FIN_ACCOUNTS_TOTAL(state, data) {
      state.finAccountsTotal = data;
    },
    // RESULTS 
    SET_CURRENT_DIMENSION(state, data){
      state.results.currentDimension = data;
    },
    SET_CURRENT_CALCULATED_DRIVER(state, data){
      state.results.currentCalculatedDriver = data;
    },
    SET_TABLE_COLUMNS(state, data){
      state.results.columns = data;
    },
    SET_TABLE_ROWS(state, data){
      state.results.rows = data;
    },
    SET_DRIVERS_OFFSET(state, data){
      state.results.driverOffset = data;
    },
    SET_OFFSET(state, data){
      const newOffset = data.currentPage * state.results.pageLength - state.results.pageLength
      state.results.offset = newOffset <= 0 ?  0 : newOffset;
    },
    SET_OFFSET_NEXT(state){
      let newOffset = state.results.driverOffset + 1
      let maxOffset = state.results.totalDrivers-state.results.driverLimit >= 0 ? state.results.totalDrivers-state.results.driverLimit : 0;
      state.results.driverOffset = newOffset >= maxOffset ? maxOffset : newOffset;
    },
    SET_OFFSET_PREVIOUS(state){
      let newOffset = state.results.driverOffset - 1
      state.results.driverOffset = newOffset <= 0 ? 0 : newOffset;
    },
    SET_RESULTS_TOTAL_DRIVERS(state, data){
      state.results.totalDrivers = data
    },
    SET_DRIVERS_DROPDOWN(state, data){  
      state.results.driversDropdownList = data
    },
    SET_PAGE_LENGTH(state, data){
      state.results.pageLength = data.pageLength;
      state.results.offset = 0;
    },
    SET_RESULTS_COUNT(state, data){
      state.results.count = data
    },
    CLEAR_TABLE_DATA(state, data){
      if(data.subStore){
        state[data.subStore].rows = [];
        state[data.subStore].pageLength = 10;
        state[data.subStore].offset = 0;
        state[data.subStore].count = null;
      }
    },

    // MANAGEMENT 
    SET_TOTAL_ROWS(state, data){
      state.management.totalRows = data
    },
    SET_ERROR_ON_LOAD(state, data){
        state.management.errorOnLoad = data
    },
    SET_UPDATE_TABLE(state){
        state.management.updateTable = !state.management.updateTable
    },
    SET_UPDATE_ON_UPLOAD(state){
        state.management.updateOnUpload = !state.management.updateOnUpload
    },
    SET_ROWS(state, data){
      state.management.rows = data;
    },
    SET_NEXT_PAGE(state, data){
      state.management.offset = state.management.limit * data - state.management.limit < 0 ? 0 : state.management.limit * data - state.management.limit
    },
    SET_PREVIOUS_PAGE(state, data){
      state.management.offset =state.management.limit * data - state.management.limit < 0 ? 0 : state.management.limit * data - state.management.limit
    },
    SET_LIMIT(state, data){
      state.management.limit = data;
      state.management.offset = 0;
    },
    SET_TOTAL_TRANSACTIONS(state,data){
      state.management.totalTransactions = data;
    },
    SET_ORDER_FIELD(state, data) {
      switch (data.management.orderType) {
        case 'asc':
          state.management.orderField = data.management.orderField;
          break;
        case 'desc':
          state.management.orderField = `-${data.management.orderField}`;
          break;
        default:
          state.management.orderField = null;
          break;
        }
    },
    SET_CALCULATED_DRIVER_FORM(state,data){
      state.management.calculatedDriverForm = data
    },
    SET_DRIVER_DIMENSION(state, data){
      state.management.calculatedDriverForm.dimension = data;
    },

    SET_DRIVER_ID(state, data){
      state.management.calculatedDriverForm.driver_id = data;
    },

    SET_DRIVER_NAME(state, data){
      state.management.calculatedDriverForm.driver_name = data;
    },

    SET_DRIVER_FORMULA(state, data){
      state.management.calculatedDriverForm.driver_formula = data;
    },
    SET_DRIVER_IS_PNL_LINE(state, data){
      state.management.calculatedDriverForm.is_pl = data;
    },
    CLEAR_DRIVER_FORM(state){
      state.management.calculatedDriverForm = {
        dimension:null,
        driver_id:null,
        driver_name: '',
        driver_formula: '=',
        is_pl: false
      }
    },

    // OTHER
    SET_LAST_CALCULATION(state, data){
      state.lastCalculation = data;
    },
    CLEAR_RESULTS_DATA(state) {
      state.lastCalculation = []
    },
    SET_PNL_ROWS(state,data){
      state.pnlDrivers = data;
    },
    SET_RESULTS_DRIVER_TABLE_ROWS(state, data) {
      state.resultsByDriver.rows = data;
    }
  },
  actions: {
    
    getTableDataManagement({state, commit},{context, modelId}){
      let order = state.management.orderField ? `&ordering=${state.management.orderField}` : ''
      return context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers?model=${modelId}${order}&limit=${state.management.limit}&offset=${state.management.offset}`
        )
        .then(response => {
          let items = response.data.items
          items.forEach((item)=> {
            if (isNaN(item["formula_feedback"])  || item["formula_feedback"] == null){
                item["formula_feedback"] = ""
            }
        })
          commit('SET_ROWS', items);
          commit('SET_TOTAL_ROWS', response.data.count);
          return true;
        }).catch((err) => {
            commit("SET_ERROR_ON_LOAD", true)
        });
    },
    clearData({ commit} ) {
        commit("SET_OFFSET", 0);
        commit("SET_LIMIT", 10);
        commit("SET_ROWS", []);
        commit("SET_TOTAL_ROWS", 0);
        commit("SET_ORDER_FIELD", "");
        commit("SET_ERROR_ON_LOAD", null)
    },
    createUpdateCalculatedDriver({state, commit},{context, mode}){
      if (mode == "UPDATE") {
        const driverId = state.management.calculatedDriverForm.old_driver_id
        const dimensionId = state.management.calculatedDriverForm.dimension
        const payload = { ...state.management.calculatedDriverForm };
        delete payload.dimension;
        delete payload.old_driver_id;
        return context.$http.patch(`${calculatedDrivers}/${driverId}/dimension/${dimensionId}`, payload);
      }
            return context.$http.post(calculatedDrivers, { ...state.management.calculatedDriverForm });
    }, 
    getCalculatedDrivers({state, commit}, {context, scenarioId, subStore, modelId}){
      let limit = state.results.driverLimit ? `&limit=${state.results.driverLimit}` : "" 
      let offset = state.results.driverOffset ? `&offset=${state.results.driverOffset}` : "" 
      let dimensionID = state.results.currentDimension ? `&dimension_id=${state.results.currentDimension}` : ""

      return context.$http.get(`${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers?model=${modelId}${dimensionID}${limit}${offset}`)
      .then((res) => {
        let list = res.data.items;
        commit("SET_DRIVERS_DROPDOWN", list);
        if(state.results.currentCalculatedDriver == null){
          var calculatedDrivers = list.map(driver => {return {label: driver.name, field: driver.id};})
        }else{
            var calculatedDrivers = list.filter(cd => cd.id == state.results.currentCalculatedDriver)
              .map(driver => {
                return {
                  label: driver.name,
                  field: driver.id,
                  type: 'number',
                  formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
                };
              });
        }
        let actionField = [{
          label:"", 
          isAction: true,
          width: "95px",
        }]
        
        let data = [{
          label: "ID",
          field: "transaction_id",
        }].concat(calculatedDrivers)

        if (state.results.currentCalculatedDriver === null){
          data = data.concat(actionField)
        }
        commit("SET_TABLE_COLUMNS",data);
        commit("SET_RESULTS_TOTAL_DRIVERS",res.data.count);
        return true
      });
    },

    getResultsTableData({state, commit}, {context, scenarioId, subStore}){
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      if (!state[subStore].currentCalculatedDriver) {
        return;
      }
      return context.$http.get(`${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers/results?scenario=${scenarioId}&dimension=${state[subStore].currentDimension}&limit=${state[subStore].pageLength}${offset}`)
      .then((response) =>{
        commit("SET_TABLE_ROWS", response.data.items);
        commit("SET_RESULTS_COUNT", response.data.count)
      })
    },
    getTableData({state, commit, dispatch}, {context, scenarioId, subStore, modelId}){
      return dispatch("getCalculatedDrivers",{context:context, scenarioId: scenarioId, subStore:subStore, modelId:modelId})
      .then(() => {
        return dispatch("getResultsTableData",{context:context, scenarioId: scenarioId, subStore:subStore})
      })
    },
    list_calculated_drivers_for_pnl({ commit }, { context, modelID }) {
      return context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers?model=${modelID}`
        )
        .then(response => {
          commit('SET_PNL_ROWS', response.data.items.filter(cd => cd.is_pnl_line));
          return true;
        }).catch((err) => {
            commit("SET_ERROR_ON_LOAD", true)
        });
    },
    calculateResults({ dispatch, commit }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers/scenario/${scenarioId}/calculate`;
      return context.$http.post(resultsUrl)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, task_id, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers/scenario/${scenarioId}/cancel-calculate`;
      let payload = {
        task_id: task_id,
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${process.env.VUE_APP_URL}/api/v1/transactional-data/calculations/${scenarioId}?ordering=-started_at`;
      return context.$http.get(resultsUrl)
        .then(res => {
          let itemsForTable = []
          res.data.items.forEach((item) => {
            let line = {
              requested_at: item.requested_at, 
              started_at: item.started_at, 
              requested_by_user: item.requested_by,
              finished_at: item.finished_at,
              calculation_status: item.status.toUpperCase(),
              task_id: item.task_id,
              calculationID: item.UUID
            }
            itemsForTable.push(line)
          })
          commit("SET_LAST_CALCULATION", itemsForTable);
          
        })
    },
    getResultsByDriver({ state, commit }, { context, scenarioId }) {
      return context.$http.get(`${process.env.VUE_APP_URL}/api/v1/transactional-data/calculated-drivers/results-sum/${scenarioId}`)
        .then((response) => {
          commit("SET_RESULTS_DRIVER_TABLE_ROWS", response.data.items);
        })
    }
  }
}
